module.exports = __webpack_public_path__ + "static/media/Braun-logo-black.2006d415.svg";